<template>
  <div>
    <!-- Img -->
    <div class='img-container'>
      <img :src='carPart' class='model' ref='car' />
    </div>
    <!-- Front Hover/Clickables -->
    <div v-if='isFront' class='container'>
      <div
        v-for='(spot, index) in frontDamage'
        :key='spot' class='spot fade-in'
        v-show='(index === textBoxNumber || textBoxNumber === -1) && landscapeMode === true'
        :class='"front-pos-" + index'
        @click='showOverLay(index)'
      >
        <div class='inner-spot' />
      </div>
      <InfoBox
        v-for='(spot, index) in frontDamage'
        :key="index"
        v-show='index === textBoxNumber'
        @close='handleClose()'
        :class='"front-pos-" + index'
        class='fix-box'
        :head='front[index].head'
        :info='front[index].text'
        :id='"front" + index'
      />
    </div>
    <!-- Rear Hover/Clickables -->
    <div v-if='!isFront' class='container'>
      <div

      v-for='(spot, index) in rearDamage'
      :key='spot' class='spot fade-in'
      v-show='(index === textBoxNumber || textBoxNumber === -1) && landscapeMode === true'
      :class='"rear-pos-" + index'
      @click='showOverLay(index)'
      >
        <div class='inner-spot' />
      </div>
      <InfoBox
        v-for='(spot, index) in rearDamage'
        :key="(index + 5)"
        v-show='index === textBoxNumber'
        @close='handleClose()'
        :class='"rear-pos-" + index'
        class='fix-box'
        :head='rear[index].head'
        :info='rear[index].text'
        :id='"rear" + index'
      />
    </div>


    <div class='container fade-in'>
      <div class='modal' ref='modal' @click='handleClose'>
        For a better experience,<br/>
        please rotate your device
      </div>
      <!-- Text for Toggle Switch -->
      <div v-show='landscapeMode === true' class='front-text'>Front</div>
      <div v-show='landscapeMode === true' class='rear-text'>Rear</div>
      <!-- Toggle Switch for front/rear -->
      <div v-show='landscapeMode === true' class='flip-switch' @click='flipSwitch'>
        <div class='inner-switch' ref='innerSwitch' />
      </div>
    </div>

    <img class='preload' v-for='img of preload' :key='img' :src='img' />
  </div>
</template>

<script>
import InfoBox from '@/components/InfoBox.vue';

const preload = {};
const front = require.context('@/assets/front', false, /.jpeg$/);
const rear = require.context('@/assets/rear', false, /.jpeg$/);

export default {
  components: {
    InfoBox,
  },
  data() {
    return {
      // Preloading images
      preload: [],
      // Displays image
      carPart: front('./base_front.jpeg'),
      // Array of front damage sections
      frontDamage: ['adhesive_residue', 'chips', 'clouding', 'scratches', 'spidercracks'],
      frontHighlight: [
        { spot: 'adhesive_residue_overlay', side: 'left' },
        { spot: 'chips_overlay', side: 'right' },
        { spot: 'clouding_overlay', side: 'left' },
        { spot: 'scratches_overlay', side: 'left' },
        { spot: 'spidercracks_overlay', side: 'right' },
      ],
      front: [
        {
          head: 'Adhesive residue',
          text: 'Adhesive from protective film\n(RAPGARD) left behind after removal.',
        },
        {
          head: 'Chips',
          text: 'Small nicks in paint usually caused by\nforeign object impact. Most often\nfound on doors and wheel well edges.',
        },
        {
          head: 'Clouding',
          text: 'Milky appearance under clear coat,\ncaused by trapped moisture. Can be\nremoved with a heat gun.',
        },
        {
          head: 'Scratches',
          text: 'Long, thin gouges, caused by objects\nbrushing across surface. Often\ncaused by metal (rivets, belt buckles,\netc.) on clothing.',
        },
        {
          head: 'Spider cracks',
          text: 'Small spider-web crackles in finish,\nusually caused by a foreign object\nimpact that does not chip the paint.',
        },
      ],
      // Array of rear damage sections
      rearDamage: ['buffertrails', 'paintscuffs', 'raildust', 'swirlmarks', 'waterspots'],
      rearHighlight: [
        { spot: 'buffertrails_overlay', side: 'left' },
        { spot: 'paintscuffs_overlay', side: 'left' },
        { spot: 'raildust_overlay', side: 'right' },
        { spot: 'swirlmarks_overlay', side: 'right' },
        { spot: 'waterspots_overlay', side: 'left' },
      ],
      rear: [
        {
          head: 'Buffer trails',
          text: 'Long, wavy “ghost” lines in the finish,\ncaused by moving a rotary buffer\nquickly across the surface.',
        },
        {
          head: 'Paint scuffs',
          text: 'Different-colored streaks of paint\nthat are caused by vehicles being\nbumped into each other, transferring\nthe paint, usually from painted\nplastic components.',
        },
        {
          head: 'Rail dust',
          text: 'Rusty dust that accumulates on finish\nand glass. Can be removed with a clay\nbar and detailing spray.',
        },
        {
          head: 'Swirl marks',
          text: 'Fine circular scratches in clear coat,\noften caused by improper use of\nrotary buffer. Can also be caused by\ncar washes with rotating brushes.',
        },
        {
          head: 'Water spots',
          text: 'Mineral deposits left behind by\nevaporated water.',
        },
      ],
      // Tracks which array to use
      isFront: true,
      side: 'front',
      // Displaying a textbox
      textBoxNumber: -1,
      // Detect mobile
      isMobile: window.matchMedia('only screen and (max-width: 1050px)').matches,
      landscapeMode: true,
    };
  },
  methods: {
    flipSwitch() {
      if (this.isFront) {
        this.carPart = rear('./base_rear.jpeg');
        this.isFront = false;
        this.$refs.innerSwitch.classList.add('animate');
      } else {
        this.carPart = front('./base_front.jpeg');
        this.isFront = true;
        this.$refs.innerSwitch.classList.remove('animate');
      }
      this.textBoxNumber = -1;
    },
    showImage(spot) {
      if (this.isFront) {
        this.carPart = front(`./${this.frontDamage[spot]}.jpeg`);
      } else {
        this.carPart = rear(`./${this.rearDamage[spot]}.jpeg`);
      }
    },
    showOverLay(spot) {
      this.textBoxNumber = spot;
      if (this.isFront) {
        this.carPart = front(`./${this.frontHighlight[spot].spot}.jpeg`);
      } else {
        this.carPart = rear(`./${this.rearHighlight[spot].spot}.jpeg`);
      }
      // Mobile fix to text boxes
      if (!this.isMobile) return;
      if (this.isFront) {
        const element = document.getElementById(`front${spot}`);
        element.classList.add(`${this.frontHighlight[spot].side}`);
      } else {
        const element = document.getElementById(`rear${spot}`);
        element.classList.add(`${this.rearHighlight[spot].side}`);
      }
    },
    handleClose() {
      if (!this.isFront) {
        this.carPart = rear('./base_rear.jpeg');
      } else {
        this.carPart = front('./base_front.jpeg');
      }
      this.textBoxNumber = -1;
    },
    handleMobile() {
      setTimeout(() => {
        if (window.innerHeight > window.innerWidth) {
          this.landscapeMode = false;
          this.$refs.modal.classList.add('show');
        } else {
          this.landscapeMode = true;
          this.$refs.modal.classList.remove('show');
        }
      }, 250);
    },
    preloadImages() {
      front.keys().forEach((key) => {
        const img = new Image();
        img.src = front(key);
        preload[key] = img;
      });
      rear.keys().forEach((key) => {
        const img = new Image();
        img.src = rear(key);
        preload[key] = img;
      });
    },
  },
  mounted() {
    if (this.isMobile) {
      this.handleMobile();
    }
    this.preloadImages();
  },
  created() {
    window.addEventListener('orientationchange', () => {
      if (this.isMobile) {
        this.handleMobile();
      }
    });
  },
  destroyed() {
    window.removeEventListener('orientationchange', () => {
      if (this.isMobile) {
        this.handleMobile();
      }
    });
  },
};
</script>

<style lang="scss">
:root {
  --img-width: 0;
}
.img-container{
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
  .model {
    display: block;
    margin-left: auto;
    margin-right: auto;
    height: auto;
    width: 100vw;
  }
}
.container {
  position: relative;
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: auto;
  margin-top: -100vh;
  width: 100vw;
  .spot {
    position: fixed;
    z-index: 2;
    width: 66px;
    height: 66px;
    border-radius: 50%;
    @media screen and (max-width: 1050px) {
      width: 48px;
      height: 48px;
    }
    @media screen and (max-width: 760px) {
      width: 33px;
      height: 33px;
    }
    .inner-spot {
      position: absolute;
      width: 22px;
      height: 22px;
      opacity: 1;
      background: #00B0F0;
      border-radius: 50%;
      top: calc(50% - 11px);
      left: calc(50% - 11px);
      z-index: 4;
      @media screen and (max-width: 1050px) {
        top: calc(50% - 8px);
        left: calc(50% - 8px);
        width: 16px;
        height: 16px;
      }
      @media screen and (max-width: 760px) {
        top: calc(50% - 5.5px);
        left: calc(50% - 5.5px);
        width: 11px;
        height: 11px;
      }
    }
      &:before, &:after {
        content: '';
        position: relative;
        display: block;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        border-radius: 45px;
        background: rgba(163, 228, 233, 1);
        animation: pulse-ring 2.25s linear infinite;
      }
      &:after {
        animation-delay: .75s;
        margin-top: -100%;
      }
  }
  .front-pos-0 {
    top: 28%;
    left: 71%;
    @media screen and (max-width:1024px) {
      top: 33%
    }
    @media screen and (max-width:768px) {
      top: 28%
    }
  }
  .front-pos-1 {
    top: 43%;
    left: 44%;
    @media screen and (max-width:1024px) {
      top: 44%;
      left: 46%;
    }
    @media screen and (max-width:768px) {
      top: 43%
    }
  }
  .front-pos-2 {
    top: 43%;
    left: 61%;
  }
  .front-pos-3 {
    top: 50%;
    left: 73%;
    @media screen and (max-width:1024px) {
      top: 46%
    }
    @media screen and (max-width:768px) {
      top: 50%
    }
  }
  .front-pos-4 {
    top: 41%;
    left: 23%;
    @media screen and (max-width:1024px) {
      top: 43%
    }
    @media screen and (max-width:768px) {
      top: 41%
    }
  }
  .rear-pos-0 {
    top: 35%;
    left: 51%;
    @media screen and (max-width:1024px) {
      top: 38%
    }
    @media screen and (max-width:768px) {
      top: 35%
    }
  }
  .rear-pos-1 {
    top: 46%;
    left: 58%;
    @media screen and (max-width:1024px) {
      top: 47%
    }
    @media screen and (max-width:768px) {
      top: 46%
    }
  }
  .rear-pos-2 {
    top: 54%;
    left: 24%;
    @media screen and (max-width:1024px) {
      top: 53%
    }
    @media screen and (max-width:768px) {
      top: 54%
    }
  }
  .rear-pos-3 {
    top: 42%;
    left: 35%;
    @media screen and (max-width:1024px) {
      top: 43%
    }
    @media screen and (max-width:768px) {
      top: 42%
    }
  }
  .rear-pos-4 {
    top: 26%;
    left: 65%;
    @media screen and (max-width:1024px) {
      top: 33%;
      left: 63%;
    }
    @media screen and (max-width:768px) {
      top: 26%
    }
  }
  .fix-box {
    transform: translate(-38%, -122%);
    @media screen and (max-width: 1050px) {
      transform: translate(0);
      top: 25%;
    }
  }
  .front-text,
  .rear-text {
    position: absolute;
    top: 56px;
    font-family: 'VWTextWeb';
    font-size: 18px;
    line-height: 22px;
    color: #FFFFFF;
    @media screen and (max-width: 1050px) {
      top: 20px;
    }
  }
  .front-text {
    right: 225px;
  }
  .rear-text {
    right: 65px;
  }
  .flip-switch {
    position: absolute;
    right: 124px;
    top: 50px;
    width: 80px;
    height: 35px;
    border-radius: 25px;
    background: #00B0F0;
    z-index: 2;
    @media screen and (max-width: 1050px) {
      top: 15px;
    }
    .inner-switch {
      width: 29px;
      height: 29px;
      border-radius: 50%;
      background: #ffffff;
      margin-top: 3px;
      margin-left: 3px;
      transition: all .5s;
      z-index: 3;
    }
  }
}
.animate {
    transform: translateX(45px);
}
.fade-in {
  opacity: 0;
  animation-delay: .2s;
  animation-name: fade-in;
  animation-fill-mode: forwards;
  animation-duration: .5s;
}
.modal {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  opacity: 0;
  transition: all .5s;
  padding-top: 72px;
  height: calc(100vh - 72px);
  text-align: center;
  font-family: "VWTextWeb";
  font-size: 20px;
  font-weight: bold;
  line-height: 28px;
  background: rgba(0,0,0,.75);
  color: #ffffff;
  width: 101vw;
  @media screen and (max-width: 1050px){
    font-size: 30px;
    line-height: 35px;
    padding-top: 150px;
    height: calc(100vh - 150px);
  }
  @media screen and (max-width: 600px){
    font-size: 20px;
    line-height: 28px;
    padding-top: 72px;
    height: calc(100vh - 72px);
  }
}
.show {
  opacity: 1;
  z-index: 99;
}
.left {
  left: 5% !important;
}
.right {
  left: 69% !important;
  @media screen and (max-width: 760px) {
     left: 55% !important;
  }
}
.preload {
  position: absolute;
  top: 0;
  left: 0;
  height: 0;
  width: 0;
}
@keyframes fade-in {
  from{
    opacity: 0;
  }
  to{
    opacity: 1;
  }
}
@keyframes pulse-ring {
  0% {
    transform: scale(.33);
  }
  80%, 100% {
    opacity: 0;
  }
}
</style>
